import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import DashboardLayout from './layouts/Dashboard.vue';
import AppAlert from './components/app/AppAlert.vue';
import AppButton from './components/app/AppButton.vue';
import AppModal from './components/app/AppModal.vue';
import Snackbar from './components/app/Snackbar.vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faBookOpen,
  faColumns,
  faCaretDown,
  faCaretRight,
  faCheck,
  faDownload,
  faEdit,
  faExternalLinkAlt,
  faPalette,
  faChevronLeft,
  faChevronRight,
  faCog,
  faEllipsisH,
  faIgloo,
  faImage,
  faImages,
  faFolder,
  faGraduationCap,
  faLink,
  faCalendarWeek,
  faPlus,
  faPlusCircle,
  faCalendarTimes,
  faSignOutAlt,
  faSortAlphaUp,
  faTrash,
  faUserGraduate,
  faSortAlphaDown,
  faSpinner,
  faStar,
  faWindowClose,
  faUser,
  faUserSlash,
  faUserTimes,
  faShieldAlt,
} from '@fortawesome/free-solid-svg-icons';
import { faTwitch, faDiscord } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import Twemoji from './plugins/twemoji';
import VueDOMPurifyHTML from 'vue-dompurify-html';
import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations';
import AppFilters from './filters/index';
import VueGtag from 'vue-gtag';

Vue.config.productionTip = false;

if (process.env.NODE_ENV !== 'development') {
  Sentry.init({
    dsn:
      'https://a3c9cd13900340968d8dcd486a32ed7b@o181611.ingest.sentry.io/5249214',
    integrations: [new VueIntegration({ Vue, attachProps: true })],
    release: `maddy-app@${process.env.VUE_APP_VERSION}`,
    environment: process.env.NODE_ENV,
  });
}

library.add(
  faBookOpen,
  faCaretDown,
  faCaretRight,
  faColumns,
  faCheck,
  faCog,
  faChevronLeft,
  faChevronRight,
  faCalendarTimes,
  faDownload,
  faDiscord,
  faEllipsisH,
  faEdit,
  faExternalLinkAlt,
  faCalendarWeek,
  faIgloo,
  faImage,
  faImages,
  faFolder,
  faLink,
  faUserGraduate,
  faGraduationCap,
  faPalette,
  faPlusCircle,
  faPlus,
  faTrash,
  faTwitch,
  faStar,
  faSignOutAlt,
  faShieldAlt,
  faSortAlphaUp,
  faSortAlphaDown,
  faSpinner,
  faUser,
  faUserSlash,
  faUserTimes,
  faWindowClose,
);

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('dashboard-layout', DashboardLayout);
Vue.component('alert', AppAlert);
Vue.component('snackbar', Snackbar);
Vue.component('app-button', AppButton);
Vue.component('modal', AppModal);

Vue.use(VueDOMPurifyHTML);
Vue.use(Twemoji);
Vue.use(AppFilters);

Vue.use(
  VueGtag,
  {
    config: { id: 'UA-118323658-3' },
    enabled: false,
  },
  router,
);

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
